import { render } from "./GestionCarta.vue?vue&type=template&id=796e1f0a&scoped=true"
import script from "./GestionCarta.vue?vue&type=script&lang=js"
export * from "./GestionCarta.vue?vue&type=script&lang=js"

import "./GestionCarta.vue?vue&type=style&index=0&id=796e1f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796e1f0a"]])

export default __exports__